/** Stable codes aligned with api-gateway / `@valvur/shared-grpc` (browser-safe copy). */
export const VALVUR_ERROR_CODE = {
  UNSPECIFIED: 'UNSPECIFIED',
  UNKNOWN: 'UNKNOWN',
  COMMON_VALIDATION_FAILED: 'COMMON_VALIDATION_FAILED',
} as const;

export const VALVUR_GENERIC_ERROR_MESSAGE =
  'Something went wrong. Please try again.';
